import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      width: "1000",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "headline"
  }, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.loadingDocumentTags
    },
    on: {
      click: _vm.close
    }
  })], 1), _c("div", {
    staticClass: "text-h5"
  }, [_vm._v("Manage documents tags")]), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      disabled: _vm.loadingDocumentTags,
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.editDialogShown = true;
      }
    }
  }, [_c(VIcon, [_vm._v("mdi-plus")]), _vm._v(" New tag ")], 1)], 1), !_vm.loadingDocumentTags ? _c(VDataTable, {
    staticClass: "pa-4",
    attrs: {
      headers: _vm.headers,
      items: _vm.documentTags,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item.isVisibleToCustomer",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.isVisibleToCustomer ? _c("div", {
          staticClass: "badge success"
        }, [_vm._v("Visible")]) : _c("div", {
          staticClass: "badge danger"
        }, [_vm._v("Not visible")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.id !== _vm.DOCUMENT_TAGS.ORDER_FINAL_INVOICE.tagId ? _c("div", {
          staticClass: "table-actions"
        }, [_c("a", {
          attrs: {
            title: "Edit"
          },
          on: {
            click: function click($event) {
              return _vm.openEditTag(item);
            }
          }
        }, [_vm._v("Edit")]), _c("a", {
          attrs: {
            title: "Remove"
          },
          on: {
            click: function click($event) {
              return _vm.deleteTag(item.id);
            }
          }
        }, [_vm._v("Delete")])]) : _vm._e()];
      }
    }], null, true)
  }) : _vm._e(), _vm.loadingDocumentTags ? _c(VSkeletonLoader, {
    staticClass: "pa-4",
    attrs: {
      type: "table-row-divider@3"
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      persistent: "",
      width: "500"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.editDialogShown,
      callback: function callback($$v) {
        _vm.editDialogShown = $$v;
      },
      expression: "editDialogShown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.loadingDocumentTags
    },
    on: {
      click: _vm.cancel
    }
  })], 1), _c(VCardText, {
    staticClass: "pt-4"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Tag name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Visible to customer",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.isVisibleToCustomer,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isVisibleToCustomer", $$v);
      },
      expression: "form.isVisibleToCustomer"
    }
  })], 1)], 1), _c(VCardActions, [!_vm.form.editMode ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.form.loading,
      disabled: !_vm.form.valid,
      rounded: ""
    },
    on: {
      click: _vm.saveNewTag
    }
  }, [_vm._v(" Save ")]) : _vm._e(), _vm.form.editMode ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.form.loading,
      disabled: !_vm.form.valid,
      rounded: ""
    },
    on: {
      click: _vm.updateTag
    }
  }, [_vm._v(" Update ")]) : _vm._e()], 1)], 1)], 1), _c("confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };